<template>
  <div>
    <maintenance-info />
    <bm-privacy v-if="isViewFull" />
    <app-header v-if="isViewFull" />
    <router-view />
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/pge/components/AppHeader'
import AppFooter from '@/pge/components/AppFooter'
import { APP_VIEW } from '@/pge/const/config.const'
import { mapMutations, mapState } from 'vuex'
import MaintenanceInfo from '@/common/components/maintenanceInfo'

const IFRAME_VIEW_NAME = 'ebok'

export default {
  components: {
    MaintenanceInfo,
    AppFooter,
    AppHeader
  },
  computed: {
    ...mapState({
      isViewFull: state => state.pge.view === APP_VIEW.full
    })
  },
  methods: {
    ...mapMutations([
      'setPgeView'
    ])
  },
  created () {
    if (this.$route.query.view && this.$route.query.view === IFRAME_VIEW_NAME) {
      this.setPgeView(APP_VIEW.iframe)
    }
  }
}
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>
